/**
 * 
 * @param {*} containerEl       - legend container element ref
 * @param {string} hoverValue   - calculated halve mode-key
 * @returns 
 */
export function syncLegendHighlightDOM(containerEl, hoverValue) {
  if (!containerEl) return

  if (!hoverValue) {
    const activeBtns = containerEl.querySelectorAll('[data-highlighted="true"]')
    activeBtns.forEach(btn => btn.removeAttribute('data-highlighted'))
    return
  }

  const buttons = containerEl.querySelectorAll('[data-legend-key]')
  buttons.forEach(btn => {
    if (btn.getAttribute('data-legend-key') === hoverValue) {
      btn.setAttribute('data-highlighted', 'true')
    } else {
      btn.removeAttribute('data-highlighted')
    }
  })
}